'use client'

export { Dialog } from './Dialog'
export { DialogActions } from './DialogActions'
export { DialogBody } from './DialogBody'
export { DialogDescription } from './DialogDescription'
export { DialogTitle } from './DialogTitle'
